export default __webpack_public_path__ + "static/media/1081.737d9de3.png";